export default __webpack_public_path__ + "thumbs-down-silhouette.png";